import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { RoutePath } from "../../../../models/routePath";
import OutboundSummary from "../../components/summary/OutboundSummary";
import "./ConfirmationScreen.scss";

interface ConfirmationScreenProps {
  createdDeliveryId?: string;
}

const ConfirmationScreen = (props: ConfirmationScreenProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { createdDeliveryId } = props;

  useEffect(() => {
    // Redirect to overview after 5 seconds
    const timer = setTimeout(() => {
      navigate(RoutePath.OutboundDeliveries);
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div data-testid="confirmationScreen" className="page-content">
      <OutboundSummary isConfirmation={true} />
      <button
        className="button-link"
        onClick={() => {
          navigate(RoutePath.OutboundDeliveries);
        }}
      >
        {t("back")}
      </button>
    </div>
  );
};

export default ConfirmationScreen;
